import { RECUPERAR_URL_PUSH } from '../actions/types'

const initialState = undefined

export default function reducerUrls (state = {}, action = initialState) {
  switch (action.type) {
    case RECUPERAR_URL_PUSH: {
      return { ...state, push: action.payload }
    }
    default:
      return state
  }
}
